import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  buyEntriesCongratsDialogTitle: {
    id: 'pointsSweeps:buyEntries:congratsDialog:title',
    defaultMessage: 'Awesome!',
    description: 'Buy entries congrats dialog title',
  },
  buyEntriesCongratsDialogDescription: {
    id: 'pointsSweeps:buyEntries:congratsDialog:description',
    defaultMessage: 'You bought {entries, plural, one {# entry} other {# entries}}',
    description: 'Buy entries congrats dialog description',
  },
});
